var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { id: "login-form" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.formController(_vm.url, $event)
        }
      }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Name")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.name,
                  expression: "model.name"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "text",
                id: "name",
                name: "name",
                autocomplete: "off"
              },
              domProps: { value: _vm.model.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.model, "name", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "error invalid-feedback",
              attrs: { id: "name-error" }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Email")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.email,
                  expression: "model.email"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "email",
                id: "email",
                name: "email",
                autocomplete: "off"
              },
              domProps: { value: _vm.model.email },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.model, "email", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "error invalid-feedback",
              attrs: { id: "email-error" }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Password")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.password,
                  expression: "model.password"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "password", id: "password", name: "password" },
              domProps: { value: _vm.model.password },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.model, "password", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "error invalid-feedback",
              attrs: { id: "password-error" }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", [_vm._v("Repeat password")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.password_confirmation,
                  expression: "model.password_confirmation"
                }
              ],
              staticClass: "form-control",
              attrs: {
                type: "password",
                id: "password_confirmation",
                name: "password_confirmation"
              },
              domProps: { value: _vm.model.password_confirmation },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(
                    _vm.model,
                    "password_confirmation",
                    $event.target.value
                  )
                }
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "error invalid-feedback",
              attrs: { id: "password_confirmation-error" }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "button",
          { staticClass: "btn btn-primary", attrs: { type: "submit" } },
          [_vm._v("Sign up")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }